import throttle from 'lodash/throttle';
import viewport from './viewport';

/**
 * Modul für Einblende Effekte.
 * Setzt Klasse "active", sobald entsprechendes Element im viewport ist.
 */
class Reveal {
    constructor($elements) {
        this.elements = $elements;
        this.handleScroll = throttle(this.handleScroll.bind(this), 100);
        $(window).on('scroll', this.handleScroll.bind(this));

        // 1 Sekunde Puffer um die Wahrscheinlichkeit zu erhöhen,
        // dass alle anderen Transformationen beendet sind.
        setTimeout(() => this.handleScroll(), 500);
    }

    handleScroll() {
        this.elements.each((index, element) => {
            const $element = $(element);
            let visible;
            if ($element.data('at-bottom')) {
                visible = Reveal.isVisible($element, 1);
            } else {
                visible = Reveal.isVisible($element);
            }

            if (visible) {
                $element.removeClass('hidden');
                $element.addClass('visible');

                this.elements = this.elements.not(element);
            }
        });
    }

    static isVisible(element, factor = 0.9, offset = 0) {
        return element.offset().top < $(window).scrollTop() + (factor * viewport.height) + offset;
    }
}

class CountOnReveal extends Reveal {
    constructor($elements) {
        super($elements);
        this.elements.one('visible', event => CountOnReveal.handleCount(event));
        this.elements.each((index, element) => {
            $(element).text('0');
        });
    }

    handleScroll() {
        this.elements.each((index, element) => {
            const $element = $(element);
            let visible;
            if ($element.data('at-bottom')) {
                visible = Reveal.isVisible($element, 1);
            } else {
                visible = Reveal.isVisible($element);
            }

            if (visible) {
                $element.addClass('visible');
                $element.trigger('visible');

                this.elements = this.elements.not(element);
            }
        });
    }

    static handleCount(event) {
        const $element = $(event.currentTarget);
        const textArray = String($element.data('number')).split(' ');

        let countTo = textArray[0].replace(',', '.');
        let appendix = '';

        if (textArray.length > 1) {
            for (let i = 1; i < textArray.length; i += 1) {
                appendix += ` ${textArray[i]}`;
            }
        }

        let decimal = false;
        if (countTo.indexOf('.') > -1) {
            decimal = true;
            countTo = parseFloat(countTo);
        } else {
            countTo = parseInt(countTo, 10);
        }


        const pseudoElement = $({
            countNum: 0,
        });
        pseudoElement.animate({
            countNum: countTo,
        }, {
            duration: 2000,
            step(now) {
                if (decimal) {
                    $element.html(`${String(now.toFixed(1)).replace('.', ',')}<small>${appendix}</small>`);
                } else {
                    $element.html(`${String(Math.floor(now))}<small>${appendix}</small>`);
                }
            },
        });
    }
}

const revealExport = {
    init() {
        const $revealObjs = $('.js-reveal');

        if ($revealObjs.length) {
            this.obj = new Reveal($revealObjs);
        }

        const $countObjs = $('.js-counter');

        if ($countObjs.length) {
            // eslint-disable-next-line no-new
            new CountOnReveal($countObjs);
        }
    },
};

export default revealExport;
